import React from 'react';
import { Row,Col, Container, Button } from 'react-bootstrap';
import { Link } from 'gatsby';
import SocialMedia from '../socialbar/SocialMedia/SocialMedia';

const Intro = () => {
    return (
        <Container className="my-3">
            <Row className="align-items-center">
                <Col md={{size: 6, order: 2}}>
                    <div className="hero-img">
                        <img className="img-fluid" src="https://imgur.com/ltwg8qO.png" alt=""/>

                        {/* <img className="img-fluid" src="https://imgur.com/cOKGK27.png" alt=""/> */}
                    </div> 
                </Col>
                <Col md={6}>
                    <p className="text-green">Hello , I'm</p>
                    <h1>Solaiman Shadin</h1>
                    <ul className="text-green d-flex pl-3">
                        <li className="mr-5">Web Developer</li>
                        <li>Programmer</li>
                    </ul>
                    <p>A self-motivated and enthusiastic web developer with a deep interest in 
                        JavaScript. To work in the Software industry with modern web technologies 
                        of different local & multinational Software/ IT agencies of Bangladesh and
                         grow rapidly with increasing responsibilities. 
                    </p>
                    <div className="buttons mt-5">
                        <Link to="/about">
                            <Button variant="success" className="mr-4">About Me</Button>
                        </Link>
                        <Link to="/contact">
                            <Button variant="outline-success">Get in touch</Button>
                        </Link>
                    </div>

                    <div className="social-media-mobile d-block d-md-none">
                       <SocialMedia/>
                    </div>
                </Col>
               
            </Row>
        </Container>
        
    );
};

export default Intro;